import { Component, OnInit, HostListener, AfterContentChecked } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormArray, FormControl } from '@angular/forms';
import { DatatableClickEvent } from '@basis/angular-components';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { TabViewModule } from 'primeng/primeng';
import { FieldsetModule } from 'primeng/primeng';
import { MenuItem } from 'primeng/primeng';
import { SelectItem } from 'primeng/primeng';
import { PadraoService } from '../../service/padrao.service';
import { Message } from 'primeng/primeng';
import { SliderModule } from 'primeng/primeng';
import { BaseCrudComponent } from "../../base/base-crud.component";
import { concat } from 'rxjs/observable/concat';
import { CrudModulosSistemaComponent } from './etapas/modulo-sistema.component';
import { Sistema } from '../../entity/sistema.model';
import { NgProgress } from 'ngx-progressbar';
import { bObservableUsuario } from 'app/util/observable-util';
import { EventEmitterService } from 'app/util/emitter-service/emitter-service';
import { EVENT_MSGS_UPDATE } from 'app/util/emitter-service/nome-evento';

@Component({
  selector: 'modulos-crud',
  templateUrl: 'modulos-crud.component.html',
  styleUrls: ['./modulos-crud.component.scss']
})
export class ModulosComponent implements OnInit {

  contentCheck: number = 0;
  blockedPanel: boolean = true;
  sistemas: Array<any> = [];
  msgs: Message[] = [];
  count: number = 0;

  constructor(public service: PadraoService, public ngProgress: NgProgress, private bObservable: bObservableUsuario) {
    if (localStorage.getItem("token") != null) {
      bObservable.getValue.subscribe(perm => {
        if(perm != "" && perm){
          var userInfo = perm.obj;
          this.service.ListarTodos('sistema').subscribe(list => {
            userInfo.lotacaoDTO.find(x => x.id == localStorage.getItem('lotacao')).perfilDTO.forEach(y => {
              if(y.sistemaDTO.tipoSituacao.id == 1 && !this.sistemas.some(z => z.id == y.sistemaDTO.id)){
                this.sistemas.push(list.find(item => item.id == y.sistemaDTO.id));
              }
            });
          });
          
        }
      },
        error => (error.status == 403) ? window.location.href = 'localhost:8080/api/Autenticar/' : null
      );
    }
  }

  ngOnInit() {
    this.ngProgress.start();
    this.ngProgress.done();
    if (sessionStorage.getItem("msg") !== null) {
      this.showMsg('success', 'Mensagem de Sucesso', sessionStorage.getItem("msg"))
    }
    sessionStorage.removeItem("msg");
  }

  ngAfterContentChecked() {
    if (this.contentCheck++ > 10)
      this.blockedPanel = false;
  }

  showMsg(severity: string, summary: string, detail: string) {
    this.msgs = [];
    this.msgs.push({ severity: severity, summary: summary, detail: detail });
    EventEmitterService.get(EVENT_MSGS_UPDATE).emit(this.msgs);
  }

  clickSistem(link:string){
    window.location.href = link;
  }
}


// WEBPACK FOOTER //
// ./src/app/modulos/crud/modulos-crud.component.ts